<dx-data-grid
#gridContainerDetails
class="grid theme-dependent"
[dataSource]="dataSource"
(onSelectionChanged)="onSelectedRowsChanged($event)"
(onCellPrepared)="onCellPrepared($event)"
[allowColumnReordering]="true"
[allowColumnResizing]="true"
[showBorders]="true"
[columnAutoWidth]="true">

  <!-- Options -->
  <dxo-column-chooser [enabled]="true" mode="select" [height]="600"></dxo-column-chooser>
  <dxo-selection mode="multiple"></dxo-selection>
  <dxo-editing mode="cell" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="false"></dxo-editing>
  <dxo-state-storing
    [enabled]="true"
    [storageKey]="grilleStorageKey"
    appStorage>
  </dxo-state-storing>

  <!-- Toolbar -->
  <dxo-toolbar>
    <dxi-item location="after" locateInMenu="auto">
      <dx-load-indicator [visible]="isMerging" class='button-indicator' height="20" width="20"></dx-load-indicator>
      <dx-button
      text="Fusionner la sélection"
      icon="group"
      type="default"
      (onClick)="fusionnerSelection()"
      [disabled]="!hasValidSelection"
        stylingMode="contained"></dx-button>
    </dxi-item>
    <dxi-item name="columnChooserButton"></dxi-item>
  </dxo-toolbar>
  <!-- Colonnes -->
  <dxi-column
    dataField="isReference"
    [setCellValue]="setSelectedPartenaireReferenceId"
    [allowEditing]="true"
    caption="Utiliser pour référence">
  </dxi-column>
  <dxi-column  [allowEditing]="false" dataField="codeBoClient" caption="Code" cellTemplate="cellTemplate">
    <div *dxTemplate="let data of 'cellTemplate'">
      <a routerLink="/{{ partenaireCategorieIntitule | slice:0:-1 | lowercase }}/{{data.data.id}}">
        <span [hidden]="!data.value">{{data.value}}</span>
        <span [hidden]="data.value != null">{{data.data.codeBo}}</span>
      </a>
    </div>
  </dxi-column>
  <dxi-column [allowEditing]="false" dataField="nom" caption="Nom"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="prenom" caption="Prénom"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="intitule" caption="Intitulé"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="dateNaissance" caption="Date de naissance" dataType="date"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="telephoneFixe" caption="Téléphone fixe"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="telephonePortable" caption="Téléphone portable"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="email" caption="Email"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="identifiantEntreprise" caption="N° Tahiti / Ridet"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="actif" caption="Actif" dataType="boolean"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="adressegeographique1" caption="Adresse géographique 1" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="adressegeographique2" caption="Adresse géographique 2" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="adressegeographique3" caption="Adresse géographique 3" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="adressepostale1" caption="Adresse postale 1" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="adressepostale2" caption="Adresse postale 2" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="adressepostale3" caption="Adresse postale 3" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="boitepostale" caption="Boîte postale" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="civilite" caption="Civilité" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="profilPartenaireId" caption="Profil partenaire" [visible]="false">
      <dxo-lookup [dataSource]="profilPartenaireDataSource" valueExpr="id" displayExpr="intitule"></dxo-lookup>
  </dxi-column>
  <dxi-column [allowEditing]="false" dataField="codepostal" caption="Code postal" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="commune" caption="Commune" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="famille juridique" caption="Famille juridique" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="forme juridique" caption="Forme juridique" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="identifiantcommercial" caption="Identifiant commercial" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="identifiantentreprise" caption="Identifiant entreprise" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="raisonsociale" caption="Raison sociale" [visible]="false"></dxi-column>
  <dxi-column [allowEditing]="false" dataField="representantlegal" caption="Représentant légal" [visible]="false"></dxi-column>

</dx-data-grid>